// @flow
import { createBlogPost } from "store/reducers/blogPosts"
import { reduxForm } from "redux-form/immutable"
import NewBlogPost from "views/NewBlogPost"

import { compose } from "recompose"
import validate from "shared/utils/validate"
import handleFormErrors from "shared/utils/handleFormErrors"

export default compose(
  reduxForm({
    form: "newBlogPost",
    validate: validate({
      title: ["required"],
      url_title: ["required"],
    }),
    onSubmit: (values, dispatch) => dispatch(createBlogPost(values.toJSON())).catch(handleFormErrors),
    onSubmitSuccess: (result, _dispatch, props) => props.history.push(`/blog/${result.data.id}`),
  })
)(NewBlogPost)
